import moment from 'moment';

export const prepareStatsData = (
  eventsByDay: {
    [key: string]: { [key: string]: { [key: string]: number } };
  },
  selectedRangeOption: string,
  mode: string,
) => {
  const endDate = moment();
  let startDate;
  switch (selectedRangeOption) {
    case 'week':
      startDate = moment().subtract(1, 'weeks');
      break;
    case 'month':
      startDate = moment().subtract(1, 'months');
      break;
    case '3 months':
      startDate = moment().subtract(3, 'months');
      break;
    default:
      startDate = moment().subtract(1, 'weeks');
  }

  const productViewData: number[] = [];
  const collectionViewData: number[] = [];
  const addToCartData: number[] = [];
  const returnVisitData: number[] = [];

  const eventType =
    mode === 'integrations' ? 'klaviyoShopify' : 'klaviyoManual';

  for (
    const date = startDate;
    date.isSameOrBefore(endDate);
    date.add(1, 'days')
  ) {
    const keyDate = moment(date)
      .utc()
      .startOf('day')
      .toISOString()
      .replace(/[-:]/g, '')
      .replace(/\.\d{3}/, '')
      .replace('Z', '000Z');

    productViewData.push(eventsByDay?.[eventType]?.productView?.[keyDate] || 0);
    collectionViewData.push(
      eventsByDay?.[eventType]?.collectionView?.[keyDate] || 0,
    );
    addToCartData.push(
      (eventType === 'klaviyoShopify'
        ? eventsByDay?.[eventType]?.addedToCart?.[keyDate]
        : eventsByDay?.[eventType]?.cartAbandonment?.[keyDate]) || 0,
    );
    returnVisitData.push(eventsByDay?.[eventType]?.returnVisit?.[keyDate] || 0);
  }

  return {
    productView: productViewData.reduce((a, b) => a + b, 0),
    collectionView: collectionViewData.reduce((a, b) => a + b, 0),
    addToCart: addToCartData.reduce((a, b) => a + b, 0),
    returnVisit: returnVisitData.reduce((a, b) => a + b, 0),
  };
};
